import moment from 'moment';

export function toDateString(date: Date) {
    return moment(date).format(`YYYY-MM-DD`);
}
